<template>
    <div class="dropdown">
        <a class="btn dropdown-toggle" @click="dropdownLanguage()" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-expanded="false">
        {{currentLanguage.label}}
        </a>
        <div ref="dropdown-languages" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" v-for="language in supportedLanguages" :key="language.key" :ref="'dropdown-' + language.key" @click="selectedLanguage(language)">{{language.label}}</a>
        </div>
        
    </div>
</template>

<script>
import i18n from '@/helpers/i18n';
import { CONSTANTS } from '@/helpers/consts';

export default {
    data () {
        return {
            currentLanguage: this.value,
        }
    },
    props:{
        value: 
        {
            type: Object,
            default: () => CONSTANTS.supportedLanguages[0]
        },
        index: Number,
        supportedLanguages:
        {
            type: Array,
            default: () => CONSTANTS.supportedLanguages
        }
    },
    mounted: function()
    {
        this.currentLanguage = this.supportedLanguages.find(language => language.key == this.$i18n.locale);
        document.addEventListener('click', this.handleClickOutside);
    },
    methods:
    {
        dropdownLanguage() {
            this.$refs["dropdown-languages"].classList.toggle('d-block');
        },
        selectedLanguage(language){
            this.currentLanguage = language;
            this.$refs["dropdown-languages"].classList.remove("d-block");
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                if(this.$refs["dropdown-languages"])
                {
                    this.$refs["dropdown-languages"].classList.remove("d-block");
                }
            }
        }
    },
    watch:
    {
        value: function(val)
        {
            this.currentLanguage = val;
        },
        currentLanguage: function()
        {
            this.$emit('input', this.currentLanguage);
        }
    }
}
</script>

<style scoped>
/deep/.dropdown-item
{
  cursor: pointer;
}
#dropdownMenuLink
{
  color: var(--secondary);
  background-color: var(--primary);
}
</style>